import { Card, CardContent } from "@/components/ui/card";
import { TrendingUp, BarChart3 } from "lucide-react";

export function CostsTab({ costReport }) {
  if (!costReport) return null;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-4">
        <Card>
          <CardContent className="py-4 text-center">
            <p className="text-3xl font-bold">{costReport.summary.total_products_with_recipes}</p>
            <p className="text-sm text-muted-foreground">Productos con ficha</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="py-4 text-center">
            <p className={`text-3xl font-bold ${costReport.summary.avg_margin_pct >= 50 ? "text-emerald-500" : "text-yellow-500"}`}>
              {costReport.summary.avg_margin_pct}%
            </p>
            <p className="text-sm text-muted-foreground">Margem media</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="py-4 text-center">
            <p className="text-3xl font-bold text-red-500">{costReport.summary.waste_cost_30d?.toFixed(2)}EUR</p>
            <p className="text-sm text-muted-foreground">Desperdicio (30d)</p>
          </CardContent>
        </Card>
      </div>

      <div className="grid gap-2">
        {costReport.products?.map(p => (
          <Card key={p.product_id}>
            <CardContent className="flex items-center justify-between p-4">
              <div>
                <h3 className="font-semibold">{p.product_name}</h3>
                <p className="text-sm text-muted-foreground">
                  Precio: {p.price?.toFixed(2)}EUR | Coste: {p.cost?.toFixed(2)}EUR | Margem: {p.margin?.toFixed(2)}EUR
                </p>
              </div>
              <div className="flex items-center gap-2">
                <TrendingUp className={`w-5 h-5 ${p.margin_pct >= 60 ? "text-emerald-500" : p.margin_pct >= 40 ? "text-yellow-500" : "text-red-500"}`} />
                <span className={`text-xl font-bold ${p.margin_pct >= 60 ? "text-emerald-500" : p.margin_pct >= 40 ? "text-yellow-500" : "text-red-500"}`}>
                  {p.margin_pct}%
                </span>
              </div>
            </CardContent>
          </Card>
        ))}
        {(!costReport.products || costReport.products.length === 0) && (
          <Card>
            <CardContent className="py-12 text-center">
              <BarChart3 className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
              <p className="text-muted-foreground">Crea fichas tecnicas para ver custos e margens</p>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}
